import React from 'react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { FuelSkeleton } from '@frete.com/fuel-react';
import * as StyledList from '../ListStyles';
import * as Styled from '../Item/ItemStyles';

function Skeleton() {
  function line() {
    return (
      <FuelFlex
        defaultProps={{
          gap: 'km4',
          justifyContent: 'space-between',
          customMargin: '8px 0 0 0',
        }}
      >
        <FuelFlex defaultProps={{ gap: 'km4' }}>
          <FuelFlex
            defaultProps={{
              gap: 'km2',
              flexDirection: 'column',
              alignItems: 'flex-end',
              height: '54px',
            }}
          >
            <FuelSkeleton
              shape="pill"
              size="custom"
              width="68px"
              height="12px"
            />
            <FuelSkeleton
              shape="pill"
              size="custom"
              width="37px"
              height="12px"
            />
          </FuelFlex>
          <Styled.WrapperLine isFirstPrint={false}>
            <FuelSkeleton
              shape="circle"
              size="custom"
              width="12px"
              height="12px"
            />
          </Styled.WrapperLine>
          <FuelFlex>
            <FuelSkeleton
              shape="pill"
              size="custom"
              width="191px"
              height="12px"
            />
          </FuelFlex>
        </FuelFlex>
        <FuelFlex>
          <FuelSkeleton shape="pill" size="custom" width="98px" height="24px" />
        </FuelFlex>
      </FuelFlex>
    );
  }

  return (
    <StyledList.Wrapper data-testid="skeleton-monitoring-history">
      {Array.from({ length: 4 }, () => line())}
    </StyledList.Wrapper>
  );
}

export default Skeleton;
